import { isAnyOf, ListenerMiddlewareInstance } from "@reduxjs/toolkit";

import { language } from "@chef/constants";

import { billingApi, showNotification } from "../features";
import { showErrorNotification } from "./util";

const intl = (
  {
    no: {
      ADDRESS_ADDED: "Adresse lagt til",
    },

    se: {
      ADDRESS_ADDED: "Adress tillagd",
    },

    dk: {
      ADDRESS_ADDED: "Adresse tilføjet",
    },
  } as const
)[language];

export default (listener: ListenerMiddlewareInstance) => {
  listener.startListening({
    matcher: isAnyOf(
      billingApi.endpoints.createAddress.matchFulfilled,
      billingApi.endpoints.createAddress.matchRejected,
    ),
    effect: async (action) => {
      if (action["meta"].requestStatus === "rejected") {
        showErrorNotification(action);
      }

      if (action["meta"].requestStatus === "fulfilled") {
        showNotification({ type: "success", message: intl.ADDRESS_ADDED });
      }
    },
  });
};
